// extracted by mini-css-extract-plugin
module.exports = {"measurer":"measurer___2IRGT","correctAnswer":"correctAnswer___ETNCM","incorrectAnswer":"incorrectAnswer___1za0N"};